import React from 'react';
import ReactDOM from 'react-dom/client';
import './fonts.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Mark native Capacitor environment so CSS can suppress Android WebView quirks
if (window.Capacitor && window.Capacitor.isNativePlatform()) {
  document.body.classList.add('is-native');
}

// Prevent Android WebView IME composition from dropping characters in every input/textarea
document.addEventListener('focusin', (e) => {
  const el = e.target;
  if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA') {
    el.setAttribute('autocorrect', 'off');
    el.setAttribute('autocapitalize', 'none');
    el.setAttribute('spellcheck', 'false');
  }
}, true);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
